import { BookingHold } from 'ui/svg/BookingHold'
import { BrokenConnection } from 'ui/svg/BrokenConnection'
import { ErrorServer } from 'ui/svg/ErrorServer'
import { FirstArtLessonBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstArtLessonBookingLockedDetailed'
import { FirstArtLessonBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstArtLessonBookingUnlockedDetailed'
import { FirstBookBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstBookBookingLockedDetailed'
import { FirstBookBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstBookBookingUnlockedDetailed'
import { FirstInstrumentBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstInstrumentBookingLockedDetailed'
import { FirstInstrumentBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstInstrumentBookingUnlockedDetailed'
import { FirstLiveMusicBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstLiveMusicBookingLockedDetailed'
import { FirstLiveMusicBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstLiveMusicBookingUnlockedDetailed'
import { FirstMovieBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstMovieBookingLockedDetailed'
import { FirstMovieBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstMovieBookingUnlockedDetailed'
import { FirstMuseumBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstMuseumBookingLockedDetailed'
import { FirstMuseumBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstMuseumBookingUnlockedDetailed'
import { FirstNewsBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstNewsBookingLockedDetailed'
import { FirstNewsBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstNewsBookingUnlockedDetailed'
import { FirstRecordedMusicBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstRecordedMusicBookingLockedDetailed'
import { FirstRecordedMusicBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstRecordedMusicBookingUnlockedDetailed'
import { FirstShowBookingLockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstShowBookingLockedDetailed'
import { FirstShowBookingUnlockedDetailed } from 'ui/svg/icons/achievements/Detailed/FirstShowBookingUnlockedDetailed'
import { FirstArtLessonBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstArtLessonBookingLocked'
import { FirstArtLessonBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstArtLessonBookingUnlocked'
import { FirstBookBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstBookBookingLocked'
import { FirstBookBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstBookBookingUnlocked'
import { FirstInstrumentBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstInstrumentBookingLocked'
import { FirstInstrumentBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstInstrumentBookingUnlocked'
import { FirstLiveMusicBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstLiveMusicBookingLocked'
import { FirstLiveMusicBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstLiveMusicBookingUnlocked'
import { FirstMovieBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstMovieBookingLocked'
import { FirstMovieBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstMovieBookingUnlocked'
import { FirstMuseumBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstMuseumBookingLocked'
import { FirstMuseumBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstMuseumBookingUnlocked'
import { FirstNewsBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstNewsBookingLocked'
import { FirstNewsBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstNewsBookingUnlocked'
import { FirstRecordedMusicBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstRecordedMusicBookingLocked'
import { FirstRecordedMusicBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstRecordedMusicBookingUnlocked'
import { FirstShowBookingLocked } from 'ui/svg/icons/achievements/Simple/FirstShowBookingLocked'
import { FirstShowBookingUnlocked } from 'ui/svg/icons/achievements/Simple/FirstShowBookingUnlocked'
import { AgainIllustration } from 'ui/svg/icons/AgainIllustration'
import { CalendarIllustration } from 'ui/svg/icons/CalendarIllustration'
import { CircledCheck } from 'ui/svg/icons/CircledCheck'
import { CircledClock } from 'ui/svg/icons/CircledClock'
import { EmailSent } from 'ui/svg/icons/EmailSent'
import { EmptyFavorites } from 'ui/svg/icons/EmptyFavorites'
import { ErrorIllustration } from 'ui/svg/icons/ErrorIllustration'
import { HappyFace } from 'ui/svg/icons/HappyFace'
import { HappyFaceWithTear } from 'ui/svg/icons/HappyFaceWithTear'
import { IdCardError } from 'ui/svg/icons/IdCardError'
import { IdCardInvalid } from 'ui/svg/icons/IdCardInvalid'
import { IdCardWithMagnifyingGlass } from 'ui/svg/icons/IdCardWithMagnifyingGlass'
import { MaintenanceCone } from 'ui/svg/icons/MaintenanceCone'
import { NoBookings } from 'ui/svg/icons/NoBookings'
import { NoOffer } from 'ui/svg/icons/NoOffer'
import { PageNotFound } from 'ui/svg/icons/PageNotFound'
import { PhonePending } from 'ui/svg/icons/PhonePending'
import { ProfileDeletion } from 'ui/svg/icons/ProfileDeletion'
import { RequestSent } from 'ui/svg/icons/RequestSent'
import { SadFace } from 'ui/svg/icons/SadFace'
import { ShareChat } from 'ui/svg/icons/ShareChat'
import { SharePhones } from 'ui/svg/icons/SharePhones'
import { Speaker } from 'ui/svg/icons/Speaker'
import { TicketBooked } from 'ui/svg/icons/TicketBooked'
import { Trophy } from 'ui/svg/icons/Trophy'
import { UserBlocked } from 'ui/svg/icons/UserBlocked'
import { UserFavorite } from 'ui/svg/icons/UserFavorite'
import { RingingBell } from 'ui/svg/RingingBell'
import { RingingBellOff } from 'ui/svg/RingingBellOff'
import { UserError } from 'ui/svg/UserError'
import { UserIdentification } from 'ui/svg/UserIdentification'
import { UserNotification } from 'ui/svg/UserNotification'

export const BasicsIllustrations = {
  AgainIllustration,
  UserNotification,
  BookingHold,
  BrokenConnection,
  CalendarIllustration,
  CircledCheck,
  CircledClock,
  EmailSent,
  EmptyFavorites,
  ErrorIllustration,
  ErrorServer,
  HappyFace,
  HappyFaceWithTear,
  IdCardError,
  IdCardInvalid,
  IdCardWithMagnifyingGlass,
  MaintenanceCone,
  NoBookings,
  NoOffer,
  PageNotFound,
  PhonePending,
  ProfileDeletion,
  RequestSent,
  RingingBell,
  RingingBellOff,
  SadFace,
  ShareChat,
  SharePhones,
  Speaker,
  TicketBooked,
  Trophy,
  UserBlocked,
  UserError,
  UserFavorite,
  UserIdentification,
}

export const SimpleAchievementIllustrations = {
  FirstArtLessonBookingLocked,
  FirstArtLessonBookingUnlocked,
  FirstBookBookingLocked,
  FirstBookBookingUnlocked,
  FirstInstrumentBookingLocked,
  FirstInstrumentBookingUnlocked,
  FirstLiveMusicBookingLocked,
  FirstLiveMusicBookingUnlocked,
  FirstMovieBookingLocked,
  FirstMovieBookingUnlocked,
  FirstMuseumBookingLocked,
  FirstMuseumBookingUnlocked,
  FirstNewsBookingLocked,
  FirstNewsBookingUnlocked,
  FirstRecordedMusicBookingLocked,
  FirstRecordedMusicBookingUnlocked,
  FirstShowBookingLocked,
  FirstShowBookingUnlocked,
}

export const DetailedAchievementIllustrations = {
  FirstArtLessonBookingLockedDetailed,
  FirstArtLessonBookingUnlockedDetailed,
  FirstBookBookingLockedDetailed,
  FirstBookBookingUnlockedDetailed,
  FirstInstrumentBookingLockedDetailed,
  FirstInstrumentBookingUnlockedDetailed,
  FirstLiveMusicBookingLockedDetailed,
  FirstLiveMusicBookingUnlockedDetailed,
  FirstMovieBookingLockedDetailed,
  FirstMovieBookingUnlockedDetailed,
  FirstMuseumBookingLockedDetailed,
  FirstMuseumBookingUnlockedDetailed,
  FirstNewsBookingLockedDetailed,
  FirstNewsBookingUnlockedDetailed,
  FirstRecordedMusicBookingLockedDetailed,
  FirstRecordedMusicBookingUnlockedDetailed,
  FirstShowBookingLockedDetailed,
  FirstShowBookingUnlockedDetailed,
}
